<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services">
    <el-row class="services-panel black-inputs">
      <el-col :span="20" :offset="2" class="services-container">
        <div class="nav-toggle" @click="showHideScreenServices">
          <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
        </div>
        <div class="services-addMs-btn">
          <div class="btn-dark btn-top" @click='setVisibilityCreateMainService'>Ajouter un service</div>
        </div>
        <div v-if="showCreateMainService">
          <el-form class="services-addMs-container" ref="formCreateMainService" :model="formCreateMainService"
            label-width="0px">
            <el-form-item>
              <div>Créer un nouveau service :</div>
              <el-input placeholder="Nom du nouveau service" v-model="formCreateMainService.name" />
            </el-form-item>
            <el-button @click="createNewMainService">Créer</el-button>
          </el-form>
        </div>
        <div class="services-tabs">
          <el-radio-group v-model="radioTabSelect">
            <draggable @end="sortTab">
              <el-radio-button class="services-tab" @focus="focusNumber" v-for='ms in getMainServicesWithoutEvents'
                :key="ms.name" :id="ms.name" :label="ms.name">
                <div class="services-tab-title">{{ ms.name }}</div>
                <el-popover placement="right" width="200" trigger="manual" v-model="popupDeleteService[ms.name]"
                  popper-class="popup-delete black-inputs">
                  <p>Si vous voulez supprimer ce service, merci d'indiquer votre mot de passe</p>
                  <el-input v-model="checkPassValue" type="password"></el-input>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" class="dark" type="primary"
                      @click="popupDeleteService[ms.name] = false">Annuler</el-button>
                    <el-button type="primary" size="mini" @click="checkBeforeDelete(ms.name)">Confirmer</el-button>
                  </div>
                  <el-button slot="reference" @click="popupDeleteService[ms.name] = !popupDeleteService[ms.name]"
                    class="el-icon-close" circle>
                  </el-button>
                </el-popover>
              </el-radio-button>
            </draggable>
          </el-radio-group>
        </div>
        <div class="my-tab-pane" v-for='ms in getMainServicesWithoutEvents' :key="ms.name"
          @click="closeAllPopupDelete()">
          <el-row v-if="ms.name === radioTabSelect">
            <el-col class="services-day" v-for='d in getFormatedServicesData["daysSortedById"]' :key="d.idDay">
              <el-row :gutter="40">
                <el-col :span="8">
                  <div style="display: flex; width:100%">
                    <h2 style="" @click="visibilityFormOpenClose(d, ms.name)"
                      :class='{ "services-day-close": formatedDataServices[ms.name][d]["form"].isClosed }'>
                      {{ d }}
                      <span v-if="visibilityForm[d][ms.name]"> {{ ms.name }}</span>
                      <span v-if="formatedDataServices[ms.name][d]['form'].isClosed"> - fermé</span>
                    </h2>
                    <h5 style="flex-grow: 1; text-align:center; line-height:24px;"
                      v-if="!visibilityForm[d][ms.name] && formatedDataServices[ms.name][d]['form'].cashOn">
                      <span v-if="formatedDataServices[ms.name][d]['form'].cashType === 'caution'">C :
                        {{ formatedDataServices[ms.name][d]['form'].cashPrice }} €/couv.</span>
                      <span v-else>P : {{ formatedDataServices[ms.name][d]['form'].cashPrice }} €/couv.</span>
                    </h5>
                    <span v-else style="flex-grow: 1;"></span>
                    <h2 style="" @click="visibilityFormOpenClose(d, ms.name)"
                      :class='{ "services-day-close": formatedDataServices[ms.name][d]["form"].isClosed }'>
                      <i class="el-icon-edit" v-if="!visibilityForm[d][ms.name]"></i>
                      <i class="el-icon-arrow-up" v-if="visibilityForm[d][ms.name]"></i>
                    </h2>
                  </div>
                </el-col>
                <el-col :span="16" v-if="!formatedDataServices[ms.name][d]['form'].isClosed">
                  <div class="services-line">
                    <div class="services-line-centered">
                      <div class="services-line-container">
                        <!-- left -->
                        <div class="services-line-service" style='left:0'>
                          <div class="services-line-point">
                            <span v-if="haveCapacityMin(ms, d)">
                              <el-popover v-if="visibilityForm[d][ms.name]" placement="top" trigger="click"
                                class="black-inputs">
                                <div class="black-inputs">
                                  <el-input-number @change="checkIntervalNull(ms.name, d, 0)" :min="-1"
                                    v-model="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity"></el-input-number>
                                </div>
                                <div slot="reference" class="clickBox">
                                  {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity }}</div>
                              </el-popover>
                              <span v-else>
                                <span v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity > 0 ||
                                  formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity < 0">
                                  {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity }}
                                </span>
                              </span>
                            </span>
                          </div>
                          <div class="services-line-hour">{{ formatedDataServices[ms.name][d]['form'].opening }}</div>
                        </div>
                        <!-- range -->
                        <div class="services-line-service"
                          v-for="hInter in getNumberOfIntervalServiceDyna(d, formatedDataServices[ms.name][d]['form'])"
                          :key="hInter.id"
                          :style="{ left: ((hInter.id) / (getNumberOfIntervalServiceDyna(d, formatedDataServices[ms.name][d]['form']).length + 1)) * 100 + '%' }">
                          <div v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab &&
                            formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id] &&
                            formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length > 0">
                            <div class="services-line-minipoint"
                              v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity === 0 && !visibilityForm[d][ms.name]">
                            </div>
                            <div class="services-line-point" v-else>
                              <el-popover v-if="visibilityForm[d][ms.name]" placement="top" trigger="click"
                                class="black-inputs">
                                <div class="black-inputs">
                                  <el-input-number @change="checkIntervalNull(ms.name, d, hInter.id)" :min="-1"
                                    v-model="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity"></el-input-number>
                                </div>
                                <div slot="reference" class="clickBox">
                                  {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity }}
                                </div>
                              </el-popover>
                              <span v-else>
                                <span
                                  v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab &&
                                    formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id] &&
                                    (formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity > 0 ||
                                      formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity < 0)">
                                  {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity }}
                                </span>
                              </span>
                            </div>
                            <div class="services-line-minihour">{{ hInter.hour }}</div>
                          </div>
                          <div v-else>
                            <div class="services-line-minipoint"></div>
                            <div class="services-line-minihour">{{ hInter.hour }}</div>
                          </div>
                        </div>
                        <!-- right -->
                        <div class="services-line-service" style='left:98%'>
                          <div class="services-line-point">
                            <span v-if="haveCapacityMax(ms, d)">
                              <el-popover v-if="visibilityForm[d][ms.name]" placement="top" trigger="click"
                                class="black-inputs">
                                <div class="black-inputs">
                                  <el-input-number
                                    @change="checkIntervalNull(ms.name, d, formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1)"
                                    :min="-1"
                                    v-model="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1].capacity"></el-input-number>
                                </div>
                                <div slot="reference" class="clickBox">
                                  {{
                                    formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length
                                      - 1].capacity }}</div>
                              </el-popover>
                              <span v-else>
                                <span
                                  v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1].capacity > 0 ||
                                    formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1].capacity < 0">
                                  {{
                                    formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length
                                      - 1].capacity }}
                                </span>
                              </span>
                            </span>
                          </div>
                          <div class="services-line-hour">{{ formatedDataServices[ms.name][d]['form'].closing }}</div>
                        </div>
                        <div class="services-line-bckg"></div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col class="services-duplicate" :offset="4" :span="12"
                  v-if="formatedDataServices[ms.name][d]['form'].isClosed">
                  <el-select v-model="formatedDataServices[ms.name][d]['duplicate']"
                    placeholder="Dupliquer le service de" @change="duplicateDataService(ms.name, d, $event)">
                    <el-option v-for='item in getOpenedFormatedData(ms.name)' :key="item.idDay"
                      :label="'Dupliquer le service de ' + item.label" :value="item.label"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-form class="services-day-parameters" v-if="visibilityForm[d][ms.name]"
                ref="formatedDataServices[ms.name][d]['form']" :model="formatedDataServices[ms.name][d]['form']">
                <el-row :gutter="40">
                  <el-col :span="12">
                    <el-form-item label="Ouverture">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].opening"
                        @input="changeThenCallInputInit($event, 'opening', ms, d)" :picker-options="{
                          start: '05:30',
                          step: '00:15',
                          end: '23:30'
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Fermeture">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].closing"
                        @input="changeThenCallPopulateCT($event, 'closing', ms, d)" :picker-options="{
                          start: '05:30',
                          step: '00:15',
                          end: '23:30'
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Capacité">
                      <el-input-number :value="formatedDataServices[ms.name][d]['form'].capacity"
                        @input="changeSimple($event, 'capacity', ms, d)" :min="1">
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Capacité par tranche horaire">
                      <el-input-number :value="formatedDataServices[ms.name][d]['form'].capacityIntervalMain"
                        :key="formatedDataServices[ms.name][d]['form'].capacityIntervalMain"
                        @input="changeThenCallPopulateCTCheckInterval($event, 'capacityIntervalMain', ms, d)" :min="0">
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Durée d'un service">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].lenghtService"
                        @input="changeSimple($event, 'lenghtService', ms, d)" :picker-options="{
                          start: '00:30',
                          step: '00:30',
                          end: '3:30'
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                    <el-form-item label="Première heure pour la prise de réservation">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].hMinTakeResa"
                        @input="changeAndUpdateMaxThenCallPopulateCT($event, 'hMinTakeResa', ms, d)" :picker-options="{
                          start: formatedDataServices[ms.name][d]['form'].opening,
                          step: '00:15',
                          end: formatedDataServices[ms.name][d]['form'].closing
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                    <el-form-item label="Dernière heure pour la prise de réservation">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].hMaxTakeResa"
                        @input="changeThenCallPopulateCT($event, 'hMaxTakeResa', ms, d)" :picker-options="{
                          start: formatedDataServices[ms.name][d]['form'].opening,
                          step: formatedDataServices[ms.name][d]['form'].intervalResa,
                          end: formatedDataServices[ms.name][d]['form'].closing
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                    <el-form-item label="Intervalle de réservation">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].intervalResa"
                        @input="changeAndUpdateMaxThenCallPopulateCT($event, 'intervalResa', ms, d)" :picker-options="{
                          start: '00:05',
                          step: '00:05',
                          end: '3:00'
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                    <el-form-item label="Limite entre réservations">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].limitSecuChrono"
                        @input="changeSimple($event, 'limitSecuChrono', ms, d)" :picker-options="{
                          start: '00:15',
                          step: '00:15',
                          end: '2:00'
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Nombre min de personnes par résa">
                      <el-input-number :value="formatedDataServices[ms.name][d]['form'].nbMinByResa"
                        @input="changeSimple($event, 'nbMinByResa', ms, d)" :min="1" :max="100"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Nombre max de personnes par résa">
                      <el-input-number :value="formatedDataServices[ms.name][d]['form'].nbMaxByResa"
                        @input="changeSimple($event, 'nbMaxByResa', ms, d)" :min="1" :max="100"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Limite avant annulation">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].limitAnnulation"
                        @input="changeSimple($event, 'limitAnnulation', ms, d)" :picker-options="{
                          start: '00:00',
                          step: '01:00',
                          end: '72:00'
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Nombre max de résa pour le service">
                      <el-input-number :value="formatedDataServices[ms.name][d]['form'].nbMaxResa"
                        @input="changeSimple($event, 'nbMaxResa', ms, d)" :min="0" :max="9999"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="min-height:70px">
                    <el-form-item label="Service invisible à la réservation en ligne" style="text-align:center">
                      <el-switch v-model="formatedDataServices[ms.name][d]['form'].invisible" active-color="#00cec0"
                        inactive-color="#e95d5d">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Fermeture automatique" style="text-align:center">
                      <el-switch v-model="formatedDataServices[ms.name][d]['form'].closeAuto" active-color="#00cec0"
                        inactive-color="#e95d5d">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].closeAuto">
                    <el-form-item label="Delai avant fermeture automatique">
                      <el-time-select :value="formatedDataServices[ms.name][d]['form'].closeAutoTime"
                        @input="changeSimple($event, 'closeAutoTime', ms, d)" :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '72:00'
                        }" :clearable="false" placeholder="Select time">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <!----- CASH  ----->
                  <el-col :span="12">
                    <el-form-item label="Caution ou prépaiement" style="text-align:center">
                      <el-switch v-model="formatedDataServices[ms.name][d]['form'].cashOn" active-color="#00cec0"
                        inactive-color="#e95d5d">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].cashOn">
                    <el-form-item label="Type" style="text-align:center">
                      <el-select v-model="formatedDataServices[ms.name][d]['form'].cashType" placeholder="Type">
                        <el-option label="Caution" value="caution"></el-option>
                        <el-option label="Prépaiement" value="prepaiement"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].cashOn">
                    <el-form-item label="Prix / couverts" style="text-align:center">
                      <el-input class="inputEuro" placeholder="Prix / couverts"
                        v-model="formatedDataServices[ms.name][d]['form'].cashPrice"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].cashOn">
                    <el-form-item label="Couverts min." style="text-align:center">
                      <el-input class="inputCouv" placeholder="couverts min."
                        v-model="formatedDataServices[ms.name][d]['form'].cashCouv"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12"
                    v-if="formatedDataServices[ms.name][d]['form'].cashOn && formatedDataServices[ms.name][d]['form'].cashType === 'caution'">
                    <el-form-item label="Limite avant annulation" style="text-align:center">
                      <el-time-select v-model="formatedDataServices[ms.name][d]['form'].cashLimitHour" :picker-options="{
                        start: '00:00',
                        step: '01:00',
                        end: '72:00'
                      }" :clearable="true" placeholder="Limite avant annulation">
                      </el-time-select>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row class="services-day-parameters-btns" :gutter="20">
                  <el-col :span="6">
                    <el-popover placement="right" width="200" trigger="manual"
                      v-model="popupValidCloseService[ms.name + d]" popper-class="popup-delete black-inputs">
                      <p>Si vous voulez supprimer ce service, merci d'indiquer votre mot de passe</p>
                      <el-input v-model="checkPassValue" type="password"></el-input>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" class="dark" type="primary"
                          @click="popupValidCloseService[ms.name + d] = false">Annuler</el-button>
                        <el-button type="primary" size="mini"
                          @click="closeService(ms.name, d, formatedDataServices[ms.name][d]['form'])">Confirmer</el-button>
                      </div>
                      <el-button slot="reference"
                        @click="popupValidCloseService[ms.name + d] = !popupValidCloseService[ms.name + d]" class="red">
                        Supprimer
                      </el-button>
                    </el-popover>
                  </el-col>
                  <el-col :span="6">
                    <el-button class="dark" @click="undoService(ms.name, d)">Annuler</el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button
                      @click="validService(ms.name, d, formatedDataServices[ms.name][d]['form'])">Valider</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div class="link" @click='showHideLockedService'>Définir des plages d’ouverture / fermeture</div>
        <div v-if="getAllInfos.restoStripe" class="link" @click='showHideScreenCashList'>Définir des cautions ou des
          prépaiements occasionnels</div>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { Notification } from 'element-ui'
import Vue from 'vue'
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'
import { focusBlur } from '../../tools/eventTools'
import { compareTime, difTimeInMinutes, nextTime, parseTime, timeInMinutes } from '../../tools/timeTool'

export default {
  name: 'Services',
  components: { draggable },
  data() {
    return {
      showCreateMainService: false,
      showEditMainService: false,
      checkPassValue: '',
      formCreateMainService: {
        name: '',
        order: 0
      },
      formEditMainService: {
        name: '',
        lastName: '',
        order: 0
      },
      formatedDataServices: {},
      visibilityForm: {},
      editableTabsValue2: ' ',
      radioTabSelect: ' ',
      popupDeleteService: {},
      popupValidCloseService: {},
      arrayTabSelect: [],
      valueDuplicate: '',
      visible: false,
      inputKey: 0
    }
  },
  computed: {
    ...mapGetters({
      getAllServices: 'newServices/getAllServices',
      getAllInfos: 'infos/getAllInfos',
      getMainServicesWithoutEvents: 'newServices/getMainServicesWithoutEvents',
      getNumberOfIntervalService: 'newServices/getNumberOfIntervalService',
      getNumberOfIntervalServiceDyna: 'newServices/getNumberOfIntervalServiceDyna',
      getServiceFormInit: 'newServices/getServiceFormInit',
      getDefaultServiceValue: 'newServices/getDefaultServiceValue',
      getWeekdays: 'calendar/getWeekdays'
    }),
    getFormatedServicesData: function () {
      let copy = JSON.parse(JSON.stringify(this.getServiceFormInit))
      this.formatedDataServices = copy
      Object.entries(this.formatedDataServices).forEach(([service, sDatas]) => {
        Object.entries(sDatas).forEach(([day, dDatas]) => {
          if (!this.visibilityForm[day]) Vue.set(this.visibilityForm, day, {})
          if (!this.visibilityForm[day][service]) Vue.set(this.visibilityForm[day], service, false)
        })
      })
      return this.formatedDataServices
    },
    getServiceHour: function (ms, d, i) {
      let hNext = this.getFormatedServicesData[ms][d]['form'].opening
      for (let n = 1; n < i; n++) {
        hNext = nextTime(hNext, this.getFormatedServicesData[ms][d]['form'].lenghtService)
      }
      return hNext
    }
  },
  methods: {
    ...mapActions({
      createMainService: 'newServices/createMainService',
      updateMainServiceOrder: 'newServices/updateMainServiceOrder',
      removeMainService: 'newServices/removeMainService',
      updateSelectedService: 'newServices/updateSelectedService',
      showHideScreenServices: 'displayer/showHideScreenServices',
      showHideLockedService: 'displayer/showHideLockedService',
      showHideScreenCashList: 'displayer/showHideScreenCashList',
      checkPassword: 'newUsers/checkPassword'
    }),
    haveCapacityMin(ms, d) {
      if (ms && d) {
        const openingHour = parseTime(this.formatedDataServices[ms.name][d]['form'].opening)
        const minTakeHour = parseTime(this.formatedDataServices[ms.name][d]['form'].hMinTakeResa)

        return this.formatedDataServices[ms.name][d]['form'].capacityIntervalTab && this.formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length > 0 &&
          minTakeHour.hours === openingHour.hours && minTakeHour.minutes === openingHour.minutes
      }
    },
    haveCapacityMax(ms, d) {
      if (ms && d) {
        const closingHour = parseTime(this.formatedDataServices[ms.name][d]['form'].closing)
        const maxTakeHour = parseTime(this.formatedDataServices[ms.name][d]['form'].hMaxTakeResa)

        return this.formatedDataServices[ms.name][d]['form'].capacityIntervalTab && this.formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length > 0 &&
          maxTakeHour.hours === closingHour.hours && maxTakeHour.minutes === closingHour.minutes
      }
    },
    closeAllPopupDelete() {
      this.getMainServicesWithoutEvents.forEach(ms => {
        this.popupDeleteService[ms.name] = false
      })
    },
    log(evt) {
      // console.log('change', evt)
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    changeThenCallInputInit(event, key, ms, d) {
      if (event && (event !== '' || event !== ' ')) {
        Vue.set(this.formatedDataServices[ms.name][d]['form'], key, event)
      }
      this.setOverInputInit(ms.name, d)
    },
    changeHMinTakeResaThenCallPopulateCT(event, ms, d) {
      if ((event || event === 0) && (event !== '' || event !== ' ')) {
        const newMin = event
        const interval = this.formatedDataServices[ms.name][d]['form'].intervalResa
        const min = this.formatedDataServices[ms.name][d]['form'].hMinTakeResa
        const max = this.formatedDataServices[ms.name][d]['form'].hMaxTakeResa
        const close = this.formatedDataServices[ms.name][d]['form'].closing

        const totalInterval = Math.trunc(difTimeInMinutes(max, min) / timeInMinutes(interval))
        const maximumTotalInterval = Math.trunc(difTimeInMinutes(close, newMin) / timeInMinutes(interval))
        const nextMax = nextTime(newMin, interval, Math.min(totalInterval, maximumTotalInterval))

        Vue.set(this.formatedDataServices[ms.name][d]['form'], 'hMaxTakeResa', nextMax)
        Vue.set(this.formatedDataServices[ms.name][d]['form'], 'hMinTakeResa', newMin)
      }
      this.populateCapacityTab(ms.name, d)
    },
    changeAndUpdateMaxThenCallPopulateCT(event, key, ms, d) {
      if ((event || event === 0) && (event !== '' || event !== ' ')) {
        const form = this.formatedDataServices[ms.name][d].form

        const newMin = key === 'hMinTakeResa' ? event : form.hMinTakeResa
        const newInterval = key === 'intervalResa' ? event : form.intervalResa
        const max = form.hMaxTakeResa
        const close = form.closing

        const totalInterval = Math.trunc(difTimeInMinutes(max, newMin) / timeInMinutes(newInterval))
        const maximumTotalInterval = Math.trunc(difTimeInMinutes(close, newMin) / timeInMinutes(newInterval))
        const nextMax = nextTime(newMin, newInterval, Math.min(totalInterval, maximumTotalInterval))

        Vue.set(form, key, event)
        Vue.set(form, 'hMaxTakeResa', nextMax)
      }
      this.populateCapacityTab(ms.name, d)
    },
    changeThenCallPopulateCT(event, key, ms, d) {
      if ((event || event === 0) && (event !== '' || event !== ' ')) {
        Vue.set(this.formatedDataServices[ms.name][d]['form'], key, event)
      }
      this.populateCapacityTab(ms.name, d)
    },
    changeThenCallPopulateCTCheckInterval(event, key, ms, d) {
      let callPopulate = this.formatedDataServices[ms.name][d]['form'].capacityIntervalMain !== event
      if ((event || event === 0) && (event !== '' || event !== ' ')) {
        Vue.set(this.formatedDataServices[ms.name][d]['form'], key, event)
      }
      if (callPopulate) this.populateCapacityTab(ms.name, d)
    },
    changeSimple(event, key, ms, d) {
      if ((event || event === 0) && (event !== '' || event !== ' ')) {
        Vue.set(this.formatedDataServices[ms.name][d]['form'], key, event)
      }
    },
    openDeletePopup: function (name) {
      this.checkPassValue = ''
      this.popupDeleteService[name] = !this.popupDeleteService[name]
    },
    setOverInputInit: function (msSelect, dSelect) {
      let openTime = parseTime(this.formatedDataServices[msSelect][dSelect]['form'].opening)
      let minTakeResaTime = parseTime(this.formatedDataServices[msSelect][dSelect]['form'].hMinTakeResa)
      let correct = minTakeResaTime.hours > openTime.hours || (minTakeResaTime.hours === openTime.hours && minTakeResaTime.minutes > openTime.minutes)
      if (this.formatedDataServices[msSelect][dSelect]['form'].opening && !correct) {
        this.formatedDataServices[msSelect][dSelect]['form'].hMinTakeResa = this.formatedDataServices[msSelect][dSelect]['form'].opening
        let tmp = nextTime(this.formatedDataServices[msSelect][dSelect]['form'].opening, this.formatedDataServices[msSelect][dSelect]['form'].lenghtService)
        this.formatedDataServices[msSelect][dSelect]['form'].closing = tmp
        this.formatedDataServices[msSelect][dSelect]['form'].hMaxTakeResa = tmp
      }
      this.populateCapacityTab(msSelect, dSelect)
    },
    checkHoursValidity: function (msSelect, dSelect) {
      let open = parseTime(this.formatedDataServices[msSelect][dSelect]['form'].opening)
      let close = parseTime(this.formatedDataServices[msSelect][dSelect]['form'].closing)
      let max = parseTime(this.formatedDataServices[msSelect][dSelect]['form'].hMaxTakeResa)
      let min = parseTime(this.formatedDataServices[msSelect][dSelect]['form'].hMinTakeResa)
      // cas ou l'ouverture est plus grande que la fermeture
      if (open.hours > close.hours || (open.hours === close.hours && open.minutes > close.minutes)) {
        this.setOverInputInit(msSelect, dSelect)
      }
      // cas ou l'ouverture est plus grande que la première heure de prise de resa
      if (open.hours > min.hours || (open.hours === min.hours && open.minutes > min.minutes)) {
        this.formatedDataServices[msSelect][dSelect]['form'].hMinTakeResa = this.formatedDataServices[msSelect][dSelect]['form'].opening
      }
      // cas ou la dernière heure de prise de resa est plus grande que la fermeture
      if (max.hours > close.hours || (max.hours === close.hours && max.minutes > close.minutes)) {
        this.formatedDataServices[msSelect][dSelect]['form'].hMaxTakeResa = this.formatedDataServices[msSelect][dSelect]['form'].closing
      }
      // cas ou la première heure de prise de resa est plus grande que la dernière heure de prise de resa
      if (min.hours > max.hours || (min.hours === max.hours && min.minutes > max.minutes)) {
        this.formatedDataServices[msSelect][dSelect]['form'].hMinTakeResa = this.formatedDataServices[msSelect][dSelect]['form'].hMaxTakeResa
      }
    },
    populateCapacityTab: function (msSelect, dSelect) {
      // first check hours
      this.checkHoursValidity(msSelect, dSelect)
      let tmp = []
      // first
      tmp.push({
        id: 0,
        hour: this.formatedDataServices[msSelect][dSelect]['form'].opening,
        capacity: this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalMain
      })
      this.getNumberOfIntervalServiceDyna(dSelect, this.formatedDataServices[msSelect][dSelect]['form']).forEach(interval => {
        tmp.push({
          id: interval.id,
          hour: interval.hour,
          capacity: this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalMain
        })
      })
      // last
      tmp.push({
        id: tmp.length,
        hour: this.formatedDataServices[msSelect][dSelect]['form'].closing,
        capacity: this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalMain
      })
      this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalTab = tmp.slice(0)
    },
    updateCapacityTab: function (msSelect, dSelect) {
      let tmp = []
      // first
      tmp.push({
        id: 0,
        hour: this.formatedDataServices[msSelect][dSelect]['form'].opening,
        capacity: this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalTab[0].capacity
      })
      this.getNumberOfIntervalServiceDyna(dSelect, this.formatedDataServices[msSelect][dSelect]['form']).forEach(interval => {
        tmp.push({
          id: interval.id,
          hour: interval.hour,
          capacity: this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalTab[interval.id].capacity
        })
      })
      // last
      tmp.push({
        id: tmp.length,
        hour: this.formatedDataServices[msSelect][dSelect]['form'].closing,
        capacity: parseInt(this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalTab[tmp.length].capacity)
      })
      this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalTab = tmp.slice(0)
    },
    checkIntervalNull(msSelect, dSelect, id) {
      if (this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalTab[id].capacity === undefined) this.formatedDataServices[msSelect][dSelect]['form'].capacityIntervalTab[id].capacity = 0
      this.updateCapacityTab(msSelect, dSelect)
    },
    getOpenedFormatedData: function (msSelect) {
      let tmp = []
      if (this.getFormatedServicesData[msSelect] !== undefined) {
        Object.entries(this.getFormatedServicesData[msSelect]).forEach(([d, vald]) => {
          if (!vald.form.isClosed) tmp.push(vald)
        })
      }
      tmp.sort(function (a, b) {
        return a.idDay - b.idDay
      })
      return tmp
    },
    duplicateDataService: function (msSelect, dSelect, e) {
      let copy = Object.assign({}, this.formatedDataServices[msSelect][e]['form'])
      this.formatedDataServices[msSelect][dSelect]['form'] = copy
      // this.formatedDataServices[msSelect][dSelect].formIsOpen = true
      this.validService(msSelect, dSelect, this.formatedDataServices[msSelect][dSelect]['form'])
    },
    sortTab: function (evt) {
      Object.entries(evt.to.children).forEach(([order, ms]) => {
        this.updateMainServiceOrder({ name: ms.id, order: order })
      })
    },
    createNewMainService: function () {
      this.createMainService(this.formCreateMainService).then(
        (data) => {
          Notification.success({
            title: 'Nouveau service',
            message: data,
            position: 'bottom-right'
          })
          this.$refs['formCreateMainService'].resetFields()
          this.showCreateMainService = false
          this.formCreateMainService.name = ''
        },
        function (err) {
          console.error(err.code)
          let message = 'Une erreur c est produite'
          switch (err.code) {
            case 'invalid-argument':
              message = 'Veuillez renseigner le nom du service'
              break
            case undefined:
              message = err.message
              break
          }
          Notification.error({
            title: 'Erreur',
            message: message,
            position: 'bottom-right'
          })
        }
      )
    },
    checkBeforeDelete: function (ms) {
      this.checkPassword(this.checkPassValue).then(() => {
        this.deleteMainService(ms)
      })
    },
    deleteMainService: function (name) {
      this.removeMainService({ name: name }).then(
        (data) => {
          Notification.success({
            title: 'Service supprimé',
            message: data,
            position: 'bottom-right'
          })
          this.showCreateMainService = false
          this.popupDeleteService[name] = false
        },
        function (err) {
          Notification.error({
            title: 'Erreur dans la suppression',
            message: err.message,
            position: 'bottom-right'
          })
        }
      )
    },
    setVisibilityCreateMainService: function () {
      if (this.showCreateMainService) this.showCreateMainService = false
      else this.showCreateMainService = true
    },
    visibilityFormOpenClose: function (day, service) {
      if (this.visibilityForm[day][service] === true) {
        this.visibilityForm[day][service] = false
        this.updateCapacityTab(service, day)
      } else {
        this.visibilityForm[day][service] = true
        if (
          this.formatedDataServices[service][day].form &&
          (!this.formatedDataServices[service][day].form.capacityIntervalTab || this.formatedDataServices[service][day].form.capacityIntervalTab.length === 0)
        ) {
          this.populateCapacityTab(service, day)
        }
      }
    },
    initFormValues: function (servicesTab) {
      let formatedData = {}
      formatedData['daysSortedById'] = []
      // for each mainServices
      Object.entries(servicesTab).forEach(([ms, valms]) => {
        formatedData[ms] = {}
        // for each days
        Object.entries(valms).forEach(([d, vald]) => {
          if (d !== 'order') {
            formatedData[ms][d] = {}
            formatedData[ms][d]['form'] = {
              opening: vald.opening,
              closing: vald.closing,
              capacity: vald.capacity,
              capacityIntervalMain: vald.capacityIntervalMain,
              capacityIntervalTab: vald.capacityIntervalTab,
              hMaxTakeResa: vald.hMaxTakeResa,
              hMinTakeResa: vald.hMinTakeResa,
              intervalResa: vald.intervalResa,
              limitSecuChrono: vald.limitSecuChrono,
              limitAnnulation: vald.limitAnnulation,
              nbServices: vald.nbServices,
              lenghtService: vald.lenghtService,
              nbMaxByResa: vald.nbMaxByResa,
              nbMinByResa: vald.nbMinByResa,
              nbMaxResa: vald.nbMaxResa,
              closeAuto: vald.closeAuto,
              closeAutoTime: vald.closeAutoTime,
              cashOn: vald.cashOn,
              cashType: vald.cashType,
              cashPrice: vald.cashPrice,
              cashCouv: vald.cashCouv,
              cashLimitHour: vald.cashLimitHour,
              isClosed: vald.isClosed,
              invisible: vald.invisible,
              formIsOpen: false
            }
            formatedData[ms][d]['label'] = d
            formatedData[ms][d]['idDay'] = vald.idDay
            formatedData[ms][d]['duplicate'] = ''
            // sort days
            if (formatedData['daysSortedById'][vald.idDay - 1] === undefined) {
              formatedData['daysSortedById'][vald.idDay - 1] = d
            }
            this.populateCapacityTab(ms, d)
          }
        })
      })
      return formatedData
    },
    validService: function (ms, d, f) {
      let canBeValidate = true

      // check if a service exist on this part of time only if service is open and is'nt the same
      Object.entries(this.getAllServices).forEach(([msCheck, valms]) => {
        if (msCheck !== ms && valms[d] && !valms[d].isClosed && valms[d].type !== 'event') {
          if ((compareTime(valms[d].opening, this.formatedDataServices[ms][d]['form'].opening) < 0 && compareTime(valms[d].closing, this.formatedDataServices[ms][d]['form'].opening) > 0) ||
            (compareTime(valms[d].opening, this.formatedDataServices[ms][d]['form'].closing) < 0 && compareTime(valms[d].closing, this.formatedDataServices[ms][d]['form'].closing) > 0) ||
            (compareTime(valms[d].opening, this.formatedDataServices[ms][d]['form'].opening) === 0 && compareTime(valms[d].closing, this.formatedDataServices[ms][d]['form'].closing) === 0)) {
            Notification.error({
              title: 'Erreur dans les horaires',
              message: `La tranche horaire de service souhaité est déjà allouée pour le ${d} ${msCheck}`,
              position: 'bottom-right'
            })
            canBeValidate = false
          }
        }
      })

      // valid serivce
      if (canBeValidate) {
        f.isClosed = false
        let toUpdate = {}
        toUpdate['ms'] = ms
        toUpdate['services'] = this.getAllServices[ms]
        if (toUpdate['services'][`${d}`] === undefined) toUpdate['services'][`${d}`] = {}
        toUpdate['services'][`${d}`]['opening'] = f.opening
        toUpdate['services'][`${d}`]['closing'] = f.closing
        toUpdate['services'][`${d}`]['capacity'] = f.capacity
        toUpdate['services'][`${d}`]['capacityIntervalMain'] = f.capacityIntervalMain
        toUpdate['services'][`${d}`]['capacityIntervalTab'] = f.capacityIntervalTab
        toUpdate['services'][`${d}`]['hMaxTakeResa'] = f.hMaxTakeResa
        toUpdate['services'][`${d}`]['hMinTakeResa'] = f.hMinTakeResa
        toUpdate['services'][`${d}`]['intervalResa'] = f.intervalResa
        toUpdate['services'][`${d}`]['limitSecuChrono'] = f.limitSecuChrono
        toUpdate['services'][`${d}`]['limitAnnulation'] = f.limitAnnulation
        toUpdate['services'][`${d}`]['nbServices'] = f.nbServices
        toUpdate['services'][`${d}`]['lenghtService'] = f.lenghtService
        toUpdate['services'][`${d}`]['nbMaxByResa'] = f.nbMaxByResa
        toUpdate['services'][`${d}`]['nbMinByResa'] = f.nbMinByResa
        toUpdate['services'][`${d}`]['nbMaxResa'] = f.nbMaxResa
        toUpdate['services'][`${d}`]['closeAuto'] = f.closeAuto
        toUpdate['services'][`${d}`]['closeAutoTime'] = f.closeAutoTime
        toUpdate['services'][`${d}`]['cashOn'] = f.cashOn
        toUpdate['services'][`${d}`]['cashType'] = f.cashType
        toUpdate['services'][`${d}`]['cashPrice'] = f.cashPrice
        toUpdate['services'][`${d}`]['cashCouv'] = f.cashCouv
        toUpdate['services'][`${d}`]['cashLimitHour'] = f.cashLimitHour
        toUpdate['services'][`${d}`]['isClosed'] = f.isClosed
        if (f.invisible === undefined) toUpdate['services'][`${d}`]['invisible'] = false
        else toUpdate['services'][`${d}`]['invisible'] = f.invisible
        if (f.nbServices > 2) {
          toUpdate['services'][`${d}`]['hMaxTakeResa'] = nextTime(f.opening, f.lenghtService, f.nbServices - 1)
          toUpdate['services'][`${d}`]['hMinTakeResa'] = f.opening
        }
        this.updateSelectedService(toUpdate)
        this.visibilityFormOpenClose(d, ms)
      }
    },
    checkValueIsSeted: function (entrie, key, errorMessage) {
      if (!entrie[key] || entrie[key] === '' || entrie[key] === ' ') {
        Notification.error({
          title: 'Erreur dans les horaires',
          message: `La valeur renseigné n'est pas accepté pour le champ ${errorMessage}`,
          position: 'bottom-right'
        })
        return false
      }
      return true
    },
    setDefaultValue: function (entrie, key, defaultvalue) {
      if (!entrie[key] || entrie[key] === '' || entrie[key] === ' ') {
        entrie[key] = defaultvalue
      }
    },
    closeService: function (ms, d, f) {
      this.checkPassword(this.checkPassValue).then(() => {
        this.popupValidCloseService[ms + d] = false
        let copy = JSON.parse(JSON.stringify(this.getServiceFormInit))
        this.formatedDataServices = copy
        f.isClosed = true
        let toUpdate = {}
        toUpdate['ms'] = ms
        toUpdate['services'] = this.getAllServices[ms]
        if (toUpdate['services'][`${d}`] === undefined) toUpdate['services'][`${d}`] = {}
        toUpdate['services'][`${d}`]['isClosed'] = f.isClosed
        // get ids
        let day = this.getWeekdays.find((data) => data.label === d)
        let idDay = day.number
        let id = `${[day.label_3].toString()}1`
        Vue.set(toUpdate['services'], `${d}`, {})
        Vue.set(toUpdate['services'], `${d}`, this.getDefaultServiceValue(id, idDay))
        this.updateSelectedService(toUpdate)
        this.visibilityFormOpenClose(d, ms)
      })
    },
    undoService: function (ms, d) {
      let copy = JSON.parse(JSON.stringify(this.getServiceFormInit))
      this.formatedDataServices = copy
      this.visibilityFormOpenClose(d, ms)
    },
    editMainService: function (targetName) {
      this.showEditMainService = true
      this.showCreateMainService = false
      this.formEditMainService.name = targetName
      this.formEditMainService.lastName = targetName
      this.formEditMainService.order = this.getAllServices[targetName]['order']
    },
    focusNumber: function (e) {
      focusBlur()
    }
  },
  created: function () {
    let labelDays = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
    this.arrayTabSelect = this.getMainServicesWithoutEvents
    if (this.arrayTabSelect.length > 0) {
      this.radioTabSelect = this.getMainServicesWithoutEvents[0].name
      this.getMainServicesWithoutEvents.forEach((ms) => {
        this.popupDeleteService[ms] = false
        labelDays.forEach((d) => {
          this.popupValidCloseService[ms + d] = false
        })
      })
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/vars";

.clickBox {
  width: 24px;
  height: 24px;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.btn-top {
  display: inline-block;
  margin-left: 10px;
}

.link {
  text-align: center;
  text-decoration: underline;
  color: var(--color_blue_azure);
  margin-top: 10px;
  cursor: pointer;
}

.inputEuro {
  text-align: center;

  &:after {
    content: '€';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 16px;
  }
}

.inputCouv {
  text-align: center;

  &:after {
    content: 'couv.';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 14px;
  }
}
</style>
